export const IS_DEVELOPMENT = true;
